module.exports = __webpack_public_path__ + "img/mayongs.80c6f04b.png";